import { Component, OnInit } from '@angular/core';
declare var $: any;
@Component({
  selector: 'app-ct-five-two-one',
  templateUrl: './ct-five-two-one.component.html',
  styleUrls: ['./ct-five-two-one.component.scss']
})
export class CtFiveTwoOneComponent implements OnInit {
  pdfSrc: string[] = [
    '/assets/pdf/NAAC/DVV/5.2.1_List-of-students placed.pdf',
    '/assets/pdf/NAAC/DVV/5.2.1_Placement-of-outgoing-students.pdf'];
  src: string;
  heading1 = false;
  heading2 = false;
  heading3 = false;
  showTable = false;
  c241Url = 'https://gnkc.ac.in/assets/pdf/NAAC/DVV/';

  result1: { title: string, link: string }[] = [
    {
      title: '2021-22_Placement proofs',
      link: this.c241Url + '2021-22_Placement-proofs.pdf'
    },
    {
      title: '2020-21_Placement proofs',
      link: this.c241Url + '2020-21_Placement-proofs.pdf'
    },
    {
      title: '2019-20_Placement proofs',
      link: this.c241Url + '2019-20_Placement-proofs.pdf'
    },
    {
      title: '2018-19_Placement proofs',
      link: this.c241Url + '2018-19_Placement-proofs.pdf'
    },
    {
      title: '2017-18_Placement proofs',
      link: this.c241Url + '2017-18_Placement-proofs.pdf'
    }
  ]

  result: { title: string, link: string }[] = [];

  isLoading = true;
  ngOnInit(): void {
    this.changeRoute('1');
  }

  changeRoute(id: string) {
    this.isLoading = true;
    if (id === '3') {
      $(`one`).addClass('show');
      $(`two`).removeClass('show');
      $(`three`).removeClass('show');
      this.result = this.result1;
      this.heading1 = true;
      this.heading2 = false;
      this.heading3 = false;
      this.showTable = true;
    }
    if (id === '1') {
      $(`two`).addClass('show');
      $(`one`).removeClass('show');
      $(`three`).removeClass('show');
      this.heading1 = false;
      this.heading2 = true;
      this.heading3 = false;
      this.showTable = false;
      this.src = this.pdfSrc[0];
    }
    if (id === '2') {
      $(`three`).addClass('show');
      $(`one`).removeClass('show');
      $(`two`).removeClass('show');
      this.heading1 = false;
      this.heading2 = false;
      this.heading3 = true;
      this.showTable = false;
      this.src = this.pdfSrc[1];
    }
  }
  hideLoader() {
    this.isLoading = false;
  }
}
